import { createAdminResource } from 'lib/admin-kit';
import ssoProviderDomainConfig from './config';

export default createAdminResource(ssoProviderDomainConfig).Show;
